<template>
  <section>
    <h2>Authors</h2>

    <ol class="my-4" v-if="authors.length > 0">
      <li v-for="(author, index) in authors" :key="index">
        <AuthorDetails
          :author="author"
          creating
          @remove="deleteManuscriptAuthor"
        />
      </li>
    </ol>
    <h4 class="my-5" v-else>
      Author information for this manuscript has not been added. Please names of
      author(s) in order as they appear in the manuscript file.
    </h4>

    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-4">
          Add manuscript author
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form
            class="mr-2 mt-4"
            ref="addAuthorForm"
            v-model="addAuthorFormValid"
            @submit.prevent="addManuscriptAuthor"
          >
            <v-row>
              <v-col cols="4">
                <v-select
                  :items="titles"
                  outlined
                  label="Title *"
                  prepend-icon="mdi-account-outline"
                  :rules="rules.required"
                  v-model="author.title"
                ></v-select>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  outlined
                  label="First Name *"
                  :rules="rules.required"
                  v-model="author.firstName"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              outlined
              label="Last Name *"
              prepend-icon="mdi-account-group-outline"
              :rules="rules.required"
              v-model="author.lastName"
            ></v-text-field>

            <v-combobox
              v-model="author.institution"
              :items="institutions"
              item-text="name"
              item-value="name"
              label="Institution name *"
              prepend-icon="mdi-school-outline"
              outlined
              :return-object="false"
              :rules="rules.required"
            ></v-combobox>

            <v-text-field
              outlined
              label="Department / College *"
              prepend-icon="mdi-office-building-outline"
              v-model="author.department"
              :rules="rules.required"
            ></v-text-field>

            <v-text-field
              outlined
              label="Specialization (optional)"
              prepend-icon="mdi-star"
              v-model="author.specialization"
            ></v-text-field>

            <v-text-field
              outlined
              type="email"
              label="Email *"
              prepend-icon="mdi-at"
              v-model="author.email"
              :rules="rules.required"
            ></v-text-field>

            <v-text-field
              outlined
              type="phone"
              label="Phone"
              prepend-icon="mdi-phone"
              v-model="author.phone"
            ></v-text-field>

            <v-row>
              <!-- <v-col v-if="!hasPrincipal">
                <v-checkbox class="ml-8" v-model="author.isPrincipal">
                  <template v-slot:label>
                    <span>
                      This author is {{ author.isPrincipal ? "" : "not" }} the
                      principal author
                    </span>
                  </template>
                </v-checkbox>
              </v-col> -->
              <v-col v-if="!hasCorresponding">
                <v-checkbox class="ml-8" v-model="author.isCorresponding">
                  <template v-slot:label>
                    <span>
                      <!-- {{ author.isCorresponding ? "Is" : "Is not" }} -->
                      Corresponding author
                    </span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>

            <v-btn
              large
              type="submit"
              color="green lighten-3"
              class="ml-8 mt-6 mb-2"
              :disabled="!manuscript || loading || !addAuthorFormValid"
              :loading="loading"
            >
              <v-icon left>mdi-account-plus</v-icon> Add Author
            </v-btn>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </section>
</template>

<script>
import { required } from "../../../tools/rules";
import { manuscriptAuthor } from "../../../tools/manuscript";
import Institutions from "../../../data/world_universities_and_domains-min.json";
import AuthorDetails from "../../Author/Includes/AuthorDetails";

export default {
  props: {
    manuscript: {
      type: String,
    },
    authors: {
      type: Array,
      dafault: () => [],
    },
  },

  components: { AuthorDetails },

  computed: {
    hasPrincipal() {
      return [...this.authors].findIndex((a) => a.isPrincipal == true) > -1;
    },
    hasCorresponding() {
      return [...this.authors].findIndex((a) => a.isCorresponding == true) > -1;
    },
  },

  data: () => ({
    addAuthorFormValid: true,
    institutions: Institutions,

    author: manuscriptAuthor,
    loading: false,

    rules: {
      required,
    },

    titles: ["Dr.", "Prof.", "Mr.", "Miss."],
  }),

  methods: {
    resetAuthor() {
      this.author = manuscriptAuthor;
      this.$refs.addAuthorForm.reset();
    },
    async addManuscriptAuthor() {
      if (!this.manuscript) return;

      this.loading = true;

      this.$axios({
        method: "POST",
        url: `/manuscript/${this.manuscript}/authors`,
        data: this.author,
      })
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Author added",
          });

          this.resetAuthor();
          this.$emit("updated");
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not add author",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async deleteManuscriptAuthor({ _id: author }) {
      if (!this.manuscript) return;

      this.loading = true;

      this.$axios({
        method: "DELETE",
        url: `/manuscript/${this.manuscript}/authors/${author}`,
      })
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Author removed",
          });

          this.$emit("updated");
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not remove author",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>

<style lang="scss" scoped>
address {
  p {
    margin: 0.25em 0;
    padding: 0;
  }
}

li {
  padding: 1em 0;
}

li + li {
  border-top: 1px solid #dddddd;
}
</style>